// Ссылки на документацию в подписях (описания параметров конфигурации): коды юзкейсов, крайних
// случаев, правил и ADR в скобках убираются из текста и показываются в подсказке «i» (CFG-RULE-2).

const REF = String.raw`(?:[A-Z]{2,5}-(?:UC-\d+(?:\.CC-\d+)?|RULE-\d+)|ADR-\d{3})`;
const GROUP = new RegExp(String.raw`\s*\((${REF}(?:,\s*${REF})*)\)`, 'g');

export interface DocRefsText {
  text: string;
  refs: string[];
}

export function splitDocRefs(text: string): DocRefsText {
  const refs: string[] = [];
  const clean = text
    .replace(GROUP, (_match, group: string) => {
      for (const ref of group.split(',').map((item) => item.trim())) if (!refs.includes(ref)) refs.push(ref);
      return '';
    })
    .replace(/\s+([;,.:])/g, '$1')
    .trim();
  return { text: clean, refs };
}

export enum DocRefKind {
  UseCase = 'usecase',
  EdgeCase = 'case',
  Rule = 'rule',
  Adr = 'adr',
}

/** Вид записи документации по коду: юзкейс, крайний случай, правило или ADR. */
export function docRefKind(ref: string): DocRefKind {
  if (ref.startsWith('ADR-')) return DocRefKind.Adr;
  if (ref.includes('-RULE-')) return DocRefKind.Rule;
  if (ref.includes('.CC-')) return DocRefKind.EdgeCase;
  return DocRefKind.UseCase;
}

/** Строки подсказки «где искать пояснение»: код и вид записи на языке интерфейса. */
export function docRefLines(refs: readonly string[], t: (key: string, params?: Record<string, string>) => string): string[] {
  return refs.map((ref) => t('config.docRefs.line', { ref, kind: t(`config.docRefs.kinds.${docRefKind(ref)}`) }));
}
